/* eslint-disable prettier/prettier */
import React from 'react';
import Page from 'Common/Layout/Page';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import PropTypes from 'prop-types';
import DataTable from 'Common/Table/DataTable';
import Section from 'Common/Layout/Section';

const View = ({
    data,
}) => {

    const schema = [
        { field: "name", label: "Task Name" },
        { field: "formattedDate", label: "Date" },
        { field: "statusImage", label: "Status" },
        { field: "message", label: "Message" }
	];

	return (
        <Page title="Retrieve Task History">		
            <Section>
                <h3 class="sr-only">Task History</h3>
				<div className="container">
					<DataTable
						dataSource={data}
						keyField="id"
						schema={schema}
						pagination
					/>
				
				</div>
			</Section>
		</Page>
	);
};

View.propTypes = {
	data: PropTypes.array.isRequired,
};
export default View;
